import { Map,Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { FlatRectRecord } from "../../helper/FlatRectRecord";
import { ItemDisplayRecord } from "../shared/ItemDisplayRecord";

export const RelationshipItemDisplayRecord = Record({
  itemDisplay: ItemDisplayRecord(),
  rect: FlatRectRecord(),
  indentationLevel: 0,
  hasChildren: false,
  childrenExpanded: false,
  columnData: Map(),
  columnAgeData: Map()
});

const data = {
  objects: {
    // titleMetrics: "TextMetricsRecord",
    itemDisplay: "ItemDisplayRecord",
    rect: "FlatRectRecord"
  },
  collections: {
    columnData: "RelationshipEventColumnDataDisplayRecord"
  }
};
createFromJS.registerCallback(
  "RelationshipItemDisplayRecord",
  createFromJS.createNestedCallback(RelationshipItemDisplayRecord, data)
);
